<template>
  <!-- Start order container -->
  <div class="orderDetails">
    <!-- Start title -->
    <BlockHeader :title="title" faIconClass="fas fa-shopping-cart" />
    <!-- End Title -->
    <OrderItems v-if="hasItems" /><!-- items list -->
    <Tll v-if="hasItems" /><!-- Tll remaining days -->
    <TaxRate v-if="hasItems" /><!-- Tax rate -->
    <!-- Start Total amount -->
    <div class="orderDetails--totalAmount" v-if="totalAmount">
      <div class="row">
        <span class="orderDetails--totalAmount__title">
          {{totalAmount === '0.00' || tllRemainingDays ? "Total to pay now" : "Total"}}
        </span>
        <span class="orderDetails--totalAmount__price">
          {{currency}} {{ tllRemainingDays ? "0.00" : totalAmount }}
        </span>
      </div>
      <span v-if="isSubscription" class="orderDetails--totalAmount__price">
        <BillingFrequency/>
      </span>
      <hr>
    </div>
    <!-- End Total amount -->
  </div>
  <!-- End order container -->
</template>

<script>
import { mapState } from 'vuex'
import CartCoupon from '../organisms/CartCoupon.vue'
import OrderItems from '../molecules/OrderItems.vue'
import Tll from '../molecules/Tll.vue'
import TaxRate from '../molecules/TaxRate.vue'
import BillingFrequency from '../molecules/BillingFrequency.vue'
import BlockHeader from '../molecules/BlockHeader.vue'

export default {
  computed: mapState({
    items: state => state.cart.items,
    totalAmount: state => state.cart.totalAmount,
    currency: state => state.cart.currency,
    isSubscription: state => state.cart.isSubscription,
    tllRemainingDays: state => state.cart.items[0] ? state.cart.items[0].tll_remaining_days : 0,
    hasItems () {
      return this.items !== undefined && this.items.length > 0
    }
  }),
  props: ['title'],
  components: {
    CartCoupon,
    BillingFrequency,
    OrderItems,
    Tll,
    TaxRate,
    BlockHeader
  }
}
</script>



// WEBPACK FOOTER //
// OrderDetails.vue?1d7392dc